import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getLineItemGroupingKey } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import {
  getAllSerialNumbers,
  getSerialNumberForUnit,
  getSerialNumbersByLineItemGroupingKey,
} from "@redotech/redo-fulfillment-group-common/scan-serial-numbers";
import {
  getExpandedItems,
  getItemizedGroupingConfig,
} from "./fulfillment-group-csv-utils";

export const SerialNumberCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Serial number",
    cell: (row) => {
      return getAllSerialNumbers(row.scanVerifiedItemized).join(", ");
    },
    expandedCsvCell: (row, expansionIndex) => {
      const expandedItems = getExpandedItems(row) ?? [];
      const itemizedConfig = getItemizedGroupingConfig(row);
      if (itemizedConfig) {
        const item = expandedItems[expansionIndex];
        if (!item) {
          return "";
        }
        return (
          getSerialNumbersByLineItemGroupingKey(
            row.items,
            row.scanVerifiedItemized,
            itemizedConfig,
          )
            .get(getLineItemGroupingKey(item, itemizedConfig))
            ?.join(", ") ?? ""
        );
      }
      return getSerialNumberForUnit(
        expandedItems,
        expansionIndex,
        row.scanVerifiedItemized,
      );
    },
  };
